module.exports = __webpack_public_path__ + "static/media/Motorista.9c56e8d3.svg";